import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MainContext } from '../../../Context/MainContext';

const Modal = ({ content, title, footer, id, size='md', noClose=false, btnCloseRef }) => {
    const { setStatus } = useContext(MainContext);

    return (
    <div className='modal fade' id={id} onKeyDown={e => e.key === 'Enter' && e.preventDefault()} data-bs-keyboard={noClose ? 'false' : 'true'} data-bs-backdrop='static' tabIndex={-1} aria-labelledby={`${id}-label`} aria-hidden='true' >
        <div className={`modal-dialog modal-dialog-centered modal-${size}`} >
            <div className='modal-content'>
                <div className='modal-header py-2 px-3'>
                    <h1 className='modal-title fw-normal fs-5 m-0 p-0' id={`${id}-label`}>
                        { title }
                    </h1>
                    <button className={`btn-close ${noClose ? 'd-none' : ''}`} data-bs-dismiss='modal' aria-label='Close' onClick={e => {e.preventDefault(); setStatus({});}} ref={btnCloseRef}></button>
                </div>
                <div className='modal-body pt-2'>
                    { content }
                </div>
                { footer && 
                    <div className='modal-footer p-1'>
                        { footer }
                    </div>
                }
            </div>
        </div>
    </div>
);};

Modal.propTypes = {
    content: PropTypes.object,
    footer: PropTypes.object,
    title: PropTypes.string,
    id: PropTypes.string,
    size: PropTypes.string
};

export default Modal;